/**
 * Contact page, the missions — the services as cards, at night. Picking one
 * writes the first line of the message ("Mission: …"), sends its title in
 * the form's `mission` field (kept apart in the back office) and heads to the
 * form; `?mission=` (from the mission board of the home page) picks it on
 * arrival. The cards are the server's
 * (templates/site/sections/contact/missions.html.twig).
 *
 * @module sections/contact/missions
 */

import { REDUCED_MOTION } from '../../config.js';
import { $, $$ } from '../../lib/dom.js';
import { gsap } from '../../lib/gsap.js';
import { scrollToTarget } from '../../lib/scroll.js';

const MISSION_LINE = /^Mission: [^\n]*\n*/;

export function animate() {
    const missions = $$('[data-mission]');
    const form = $('[data-form]');

    if (!missions.length || !form) {
        return;
    }

    const message = form.elements.namedItem('message');
    const missionField = form.elements.namedItem('mission');
    const chip = $('[data-mission-chip]');
    const chipName = $('[data-mission-name]');
    const clear = $('[data-mission-clear]');

    /**
     * @param {HTMLElement | null} picked - The chosen card, or null to clear.
     * @param {boolean} travel - Head to the message, caret after the mission.
     */
    const choose = (picked, travel) => {
        const name = picked?.dataset.mission ?? '';

        missions.forEach((card) => {
            const on = card === picked;

            card.setAttribute('aria-pressed', String(on));
            card.classList.toggle('is-picked', on);
            card.classList.toggle('is-dimmed', Boolean(picked) && !on);
            $('.mission__state', card).textContent = on ? 'Selected' : 'Select';
        });

        const body = message.value.replace(MISSION_LINE, '');
        message.value = name ? `Mission: ${name}\n\n${body}` : body;
        missionField.value = name;
        message.dispatchEvent(new Event('input', { bubbles: true }));

        chip.hidden = !name;
        chipName.textContent = name;

        if (picked && !REDUCED_MOTION) {
            gsap.fromTo(picked, { scale: 0.96 }, { scale: 1, duration: 0.6, ease: 'back.out(3)' });
        }

        if (picked && travel) {
            gsap.delayedCall(REDUCED_MOTION ? 0 : 0.45, () => {
                scrollToTarget(message, 'center center');

                gsap.delayedCall(REDUCED_MOTION ? 0 : 1.1, () => {
                    const end = message.value.length;
                    message.focus({ preventScroll: true });
                    message.setSelectionRange(end, end);
                });
            });
        }
    };

    missions.forEach((card) => {
        card.addEventListener('click', () => choose(card.getAttribute('aria-pressed') === 'true' ? null : card, true));
    });

    clear.addEventListener('click', () => {
        choose(null, false);
        message.focus();
    });

    // Sent: the form resets, so does the mission.
    form.addEventListener('reset', () => window.setTimeout(() => choose(null, false), 0));

    // ?mission=… — chosen on the mission board of the home page.
    const wanted = new URLSearchParams(window.location.search).get('mission');
    const match = missions.find((card) => card.dataset.mission === wanted);

    if (match) {
        choose(match, false);
    }
}
